// @flow
import React from 'react'
import './styles.scss'
// https://reactjsexample.com/a-very-simple-echarts-wrapper-for-react/
import ReactEcharts from 'echarts-for-react'
import echarts from 'echarts'

export class BarChart extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800,
      displayData: {},
      chartOptions: {},
      echartInstance: null
    }
    this.handleEvents = {
      mouseover: this.onChartHover,
      mouseout: this.onChartLeave
    }
  }

  componentDidMount() {
    //console.log('chart componentDidMount:')
    //console.log('chartData:', this.props.chartData)
  }

  /*
  UNSAFE_componentWillReceiveProps() {
    //console.log('componentWillReceiveProps:')
    //console.log('chartData:', this.props.chartData)
    this.setState({ chartOptions: this.getOption() })
  }
  */

  // Chart Options
  // https://ecomfe.github.io/echarts-doc/public/en/option.html#title
  getOption = function() {
    //console.log('getoption')
    return {
      grid: {
        top: '3%',
        left: '1%',
        right: '13%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01],
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        minInterval: 20,
        axisLabel: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#eee'
          }
        }
      },
      yAxis: {
        type: 'category',
        data: this.props.chartData.map(({ name }) => name).reverse(),
        axisTick: {
          show: false
        },
        axisLabel: {
          fontSize: 14
        }
      },
      itemStyle: {
        color: '#CAC4B3'
      },
      barMaxWidth: 22,
      label: {
        show: true,
        position: 'right',
        fontSize: 14,
        formatter: function(value) {
          //console.log('label value:', value)
          return value.data.value + '%'
        }
      },
      series: [
        {
          name: 'resultate',
          type: 'bar',
          data: this.props.chartData.reverse()
        }
      ],
      animation: false
    }
  }

  render() {
    //console.log('### CHART RENDER ###')
    //console.log('CHART DATA')
    //console.log(this.props.chartData)
    // register theme object
    // theme object format example: https://github.com/apache/incubator-echarts/blob/master/theme/dark.js
    echarts.registerTheme('ta_theme', {
      backgroundColor: 'transparent',
      textStyle: {
        fontSize: '16',
        fontFamily:
          'TamediaChart,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif',
        color: '#333'
      },
      title: {
        textStyle: {
          color: '#333',
          fontSize: '22'
        },
        subtextStyle: {
          color: '#5f5f5f',
          fontSize: '18'
        }
      },
      legend: {
        left: 'left',
        orient: 'vertical',
        itemGap: 7,
        padding: [0, 0, 0, 10],
        itemWidth: 10,
        textStyle: {
          fontSize: '16'
        },
        show: false
      },
      label: {
        show: false
      },
      smooth: true
    })

    return (
      <div className='echart'>
        <ReactEcharts
          ref={e => {
            this.echarts_react = e
          }}
          onEvents={this.handleEvents}
          option={this.getOption()}
          opts={{ renderer: 'canvas' }}
          notMerge
          theme='ta_theme'
          style={{ height: this.state.isMobile ? '11em' : '12em' }}
        />
      </div>
    )
  }
}
